<template>
  <div class="loader__wrapper" :class="{'loader__wrapper--static': isStatic}">
    <div class="loader__spinner" :class="[size]"></div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      default: 'md',
      type: String,
    },
    isStatic: {
      default: false,
      type: Boolean,
    },
  },
}
</script>

<style lang="scss" scoped>
.loader {
  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: absolute;
    inset: 0;
    z-index: 10;
    background-color: rgba(255, 255, 255, 0.5);
    pointer-events: none;

    &--static {
      position: static;
    }
  }

  &__spinner {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 3px solid $brand-secondary;
    border-top-color: #c4c4c4;
    -webkit-animation: 1s spin linear infinite;
    animation: 1s spin linear infinite;

    &.sm {
      width: 24px;
      height: 24px;
      border-width: 2px;
    }
  }
}

@keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
